import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import Components from "./components/components";
import https from "./utils/api";
import url from "./utils/url";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import TDesign from "tdesign-vue";
import "tdesign-vue/es/style/index.css";
import "./assets/css/global.css";
Vue.config.productionTip = false;
Vue.prototype.$https = https;
Vue.prototype.$url = url;
Vue.prototype.$store = store;
Vue.use(Components);
Vue.use(ElementUI);
Vue.use(TDesign);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
